import { routes as unpostedBillsRoutes } from "./unposted-bills/routes";
import { routes as postedBillsRoutes } from "./posted-bills/routes";
import { routes as invoicesReport } from "./invoices/routes";
import { routes as invoicePerVisitReport } from "./invoice-per-visit/routes";
import { routes as cashOutsReport } from "./cash-out/routes";
import { routes as receivedPaymentRoutes } from "./received-payments/routes";
import { routes as weiveredBillsRoutes } from "./weivered-bills/routes";
import { routes as combinedInvoicesRoutes } from "./combined-invoices/routes";
import { routes as mpesapayRoutes } from "./mpesa-pay/routes";
import { routes as nhifInvoicesRoutes } from "./nhif-monthly-report/routes";
import { routes as departmentalRoutes } from "./departmental/routes";
export const routes = (prefix = `reports`, pre = `accounts-finance`) => [
    ...unpostedBillsRoutes(prefix, pre),
    ...postedBillsRoutes(prefix, pre),
    ...invoicesReport(prefix, pre),
    ...invoicePerVisitReport(prefix, pre),
    ...cashOutsReport(prefix, pre),
    ...receivedPaymentRoutes(prefix, pre),
    ...weiveredBillsRoutes(prefix, pre),
    ...combinedInvoicesRoutes(prefix, pre),
    ...mpesapayRoutes(prefix, pre),
    ...departmentalRoutes(prefix, pre),
    ...nhifInvoicesRoutes(prefix,pre),
    {
        name: `${prefix}.${pre}.index`,
        path: `/${prefix}/${pre}`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.index`,
                PageDescription: `Accounts and finance reports`,
            },
        },
    },{
        name: `${prefix}.${pre}.invoicingindex`,
        path: `/${prefix}/${pre}`,
        component: () => import('./InvoicingIndex.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.invoicingindex`,
                PageDescription: `Invoicing Accounts and finance reports`,
            },
        },
    },
    {
        name: `${prefix}.${pre}.cancelled-bills-report.index`,
        path: `/${prefix}/${pre}/cancelled-bills-report`,
        component: () => import('./cancelled-bills/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.cancelled-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: cancelled Bills report",
            },
        },
    },
];